

import React from 'react'
import { BoxWrapper } from '../../../style'
import { goBack } from '../../../Utils/common';
import arrowIcon from "../../../images/arrow.png";
import { useNavigate } from 'react-router-dom';
import LoanCalculator from '../../../components/LoanCalculator/LoanCalculator';
import { Calculator } from "lucide-react";
function CalculateLoan() {
  const navigate = useNavigate();

  return (

    // <BoxWrapper  className="w100 gray" >
    //     <div className="formmainBox flex">
    //       <div className="left">
    //         <div className='center gap4 pointer' onClick={()=>goBack(navigate,"/my-dashboard/eligibility")}>
    //             <img src={arrowIcon} alt="" /> <span>Back</span>
    //         </div>
    //       </div>
    //       <div className="right">
    //       <h2>CALCULATING LOANS</h2>

    //         <LoanCalculator />
    //       </div>
    //     </div>

    //    </BoxWrapper>


    <BoxWrapper className="w-full min-h-screen bg-gray-100 p-3 sm:p-5 md:p-8">

      <div className="flex flex-col gap-5">

        {/* Back Button */}
        <div
          className="inline-flex w-fit items-center gap-2 border border-gray-300 rounded-xl px-5 py-3 cursor-pointer bg-white hover:bg-gray-50 transition-all duration-300"
          onClick={() => goBack(navigate, "/my-dashboard/eligibility")}
        >
          <img
            src={arrowIcon}
            alt="Back"
            className="w-4 transition-transform duration-300 group-hover:-translate-x-1"
          />
          <span className="font-medium text-black">Back</span>
        </div>

        {/* Card */}
        <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-5 sm:p-8 md:p-10">

          {/* Header */}
          <div className="text-center mb-8">

            <div className="flex justify-center mb-6">
              <div className="flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-2xl bg-[#EEF6FF] border border-blue-100 shadow-sm">
                <Calculator className="h-8 w-8 sm:h-10 sm:w-10 text-[#2D5F7A]" />
              </div>
            </div>



          </div>

          {/* Loan Calculator */}
          <div className="w-full">
            <LoanCalculator />
          </div>

        </div>

      </div>

    </BoxWrapper>
  )
}

export default CalculateLoan;